
import { sortNumeric, unique, keyId, screenPosition as sPosition} from '../../lib/utils'; 
import { v4 as uuidv4, v4 } from 'uuid';
import { offerDocWithDescriptionText } from '../../components/gestioneDatabase/Docs';


export const groupedOffer = (offerData) => {

    const descriptionText = !offerData ? [] : offerData?.map?.((item)=> offerDocWithDescriptionText(item))
    const uniqueDescriptions = unique("descriptionText", descriptionText)
    const uniqueProducts = [...uniqueDescriptions]?.map?.((product)=>{

        
        const sameDescription = !Array.isArray(descriptionText) ? [] : descriptionText?.filter?.((x)=>x?.descriptionText == product?.descriptionText)

        const hide = sameDescription?.every?.((x)=>x?.hide)

        const positions = sameDescription
            ?.filter?.(x=>{
                if(hide) return x?.location
                return x?.location && !x?.hide})
            ?.map?.((item)=>` ${item?.location}`)?.sort((a,b)=> sortNumeric(a,b,"POSIZIONE"))?.toString()

        const quantities = sameDescription
        ?.filter?.((y)=>{
            if(hide) return y
            return!y?.hide})
        ?.map?.((item)=> {
            if(!item?.quantity) return 1
            return Number(item?.quantity)
        })?.reduce((partialSum, a) => partialSum + a, 0)
       
        const deviceIds =  sameDescription
        ?.filter?.((y)=>{
            if(hide) return y
            return!y?.hide})
        ?.map?.((y)=>y?.deviceId).filter?.((x)=>x)
        
        const allQuantities = () => { 
            if(product?.labourProduct) return 1
            return quantities
        }

        const totalCost = () => {
         const labourHours = product?.labourHours ? Number(product?.labourHours) : 1
            if(product?.labourProduct) return  ((Number(product?.supplierPrice) * Number(labourHours))?.toFixed(2))?.toString()
            return (Number(product?.supplierPrice) * Number(allQuantities()))?.toFixed(2)?.toString()
        }
               
        const priceToClient = () =>{ 
            return (Number(product?.discountedUnitPrice) * Number(allQuantities()))?.toFixed(2)?.toString()
         }

        const profit = () => {
           return (Number(priceToClient()) - Number(totalCost()))?.toFixed(2)?.toString()
        }

  
        return {
            ...product, 
            location: positions, 
            quantity: allQuantities(),
            unitPrice: +product?.unitPrice*1.00?.toFixed(2)?.toString(),
            totalCost: totalCost(),
            priceToClient: priceToClient(),
            profit: profit(),
            deviceIds,
            labourProduct: product?.labourProduct,
            hide,
            fieldsIds: sameDescription?.map?.((x)=>x?._id),
            _id: uuidv4(),
            _key: keyId()
        }
    })
        
    return uniqueProducts
}